module.exports = __webpack_public_path__ + "static/media/call-center-female-caucasian.317ff073.png";